import { useQuery } from '@tanstack/react-query';
import { requestVideoKeys } from '../api/keys';
import { fetchTrail } from '../api/requestVideoApi';
import { STALE_TIME } from '../utils/constants';
import { normalizeTrailEvents } from '../utils/timeline';

const NO_EVENTS = [];

export const useTrailWindow = ({ activityUnitId, window }) => {
  const enabled = Boolean(activityUnitId && window);
  const query = useQuery({
    queryKey: requestVideoKeys.trail(activityUnitId, window?.start, window?.end),
    queryFn: () => fetchTrail({ activityUnitId, startMs: window.start, endMs: window.end }),
    select: normalizeTrailEvents,
    staleTime: STALE_TIME.trail,
    enabled,
  });

  return {
    events: query.data || NO_EVENTS,
    isLoading: enabled && query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
